function getDivisor(index) {
	var divisors = [1000,60,60,24,30];
	//var divisors = [30,24,60,60];
	var divisor = -1;
	if (index >= divisors.length) return divisor;
	else return divisors[index];
}
function getUnits(index) {
	switch(index){
		case 0:
			//console.log("milliseconds");
			return " ms"
			break;
		case 5:
			//console.log("mois");
			return " months"
			break;
		case 4:
			//console.log("jours");
			return " days"
			break;
		case 3:
			//console.log("heures");
			return " hours"
			break;
		case 2:
			//console.log("minutes");
			return " minutes"
			break;
		case 1:
			//console.log("secondes");
			return " secondes"
		default:
			return " error";
	}
}

function calculateDifference(lastTime) {
	var index = 0;
	var divisor = 1;
	var increment = 0;
	var find = false;

	while(!find) {
		divisor = getDivisor(index);
		if (divisor != -1) {
			lastTime = lastTime/divisor;
			if(lastTime < 1) {
				lastTime *= divisor;
				find = true;
			}
			else index++;
		}
		else find = true;
	}

	var units = getUnits(index);
	return (String(Math.round(lastTime))+units);
}


module.exports.getTimeDifference = function(val) {
	var currentTime = new Date().getTime();
	var timeLastSeen = new Date(val).getTime();
	return calculateDifference(currentTime-timeLastSeen);
}


module.exports.sliceString = function(str) {
	if (!str) return str
	if (str.length >= 7) return str.slice(0,7)
	else return str
}

module.exports.copyToClipboard = function(elementToCopy) {
	var dummy = document.createElement("textarea");
	document.body.appendChild(dummy);
	dummy.setAttribute("id","dummy_id");
	document.getElementById("dummy_id").value = elementToCopy;
	dummy.select();
	document.execCommand("copy");
	document.body.removeChild(dummy);
	// console.log(elementToCopy, " copied")
}


// WEBPACK FOOTER //
// ./src/utils/my_module.js